import { Pipe, PipeTransform } from '@angular/core';

import { FacetValue } from '@spartacus/core';

@Pipe({
  name: 'searchFacet',
  standalone: true
})
export class DpSearchFacetPipe implements PipeTransform {
  transform(values: FacetValue[], searchValue = ''): FacetValue[] {
    return searchValue
      ? (values.filter((value: FacetValue) => value?.name?.toLowerCase().includes(searchValue.toLowerCase())) ?? [])
      : values;
  }
}
